<SearchResult {href} className="search-result-anchor-status">
  <Status {index} {length}
          timelineType="search" timelineValue="search"
          {status} />
</SearchResult>
<style>
</style>
<script>
  import SearchResult from './SearchResult.html'
  import Status from '../status/Status.html'
  import { canonicalStatusUrl } from '../../_utils/canonicalStatusUrl.js'

  export default {
    components: {
      SearchResult,
      Status
    },
    computed: {
      href: ({ status }) => canonicalStatusUrl(status)
    }
  }
</script>